import { Typography } from '@snack-uikit/typography';

import { equals, isEmpty } from '@/utils/common';

import { SelectedOption } from './SelectedItem';
import s from './styles.module.scss';

type SelectedContentProps = {
  selectedOptions: string[];
  metaPlatforms: string[];
  lastVisibleSelectedItemIndex: number;
};

export function SelectedContent({
  selectedOptions,
  metaPlatforms,
  lastVisibleSelectedItemIndex,
}: SelectedContentProps) {
  const isAllPlatformsSelected = metaPlatforms && equals(selectedOptions.length, metaPlatforms.length);
  if (isEmpty(selectedOptions) || isAllPlatformsSelected) {
    return <Typography.SansLabelL> Все платформы </Typography.SansLabelL>;
  }
  return (
    <div className={s.selector_wrapper}>
      {selectedOptions.map((selected, idx) => (
        <SelectedOption
          lastVisibleSelectedItemIndex={lastVisibleSelectedItemIndex}
          key={selected}
          length={selectedOptions.length}
          optionName={selected}
          idx={idx}
        />
      ))}
    </div>
  );
}
